import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import plusFill from '@iconify/icons-eva/plus-fill';
import { LinkasRouterLink, useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField
} from '@mui/material';
// utils
import { toast } from 'react-hot-toast';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment-timezone';
//
import * as kategoriLayananService from '../services/kategorilayanan';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import {
  SettingListHead,
  SettingListToolbar,
  SettingMoreMenu
} from '../components/_dashboard/setting';
import USERLIST from '../_mocks_/user';
import isEligible from '../utils/roleEligibleGetter';
import AccessRequired from './AccessRequired';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'name', label: 'name', alignRight: false },
  { id: 'description', label: 'Deskripsi', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' }
];

//

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user?.name?.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user?.summary?.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

Setting.propTypes = {
  user: PropTypes.object.isRequired
};

export default function Setting({ user }) {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [kategoriLayanan, setKategoriLayanan] = React.useState([]);
  const [toggleRefresh, setToggleRefresh] = React.useState(false);
  const [description, setDescription] = React.useState('');
  const navigate = useNavigate();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = kategoriLayanan.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const updateData = async (rowData) => {
    confirmAlert({
      title: 'Konfirmasi',
      message: 'Apakah Anda yakin akan update data ini?',
      buttons: [
        {
          label: 'Yakin',
          onClick: async () => {
            try {
              const body = {
                id: rowData.id,
                status: rowData.status === 'active' ? 'inactive' : 'active',
                order: rowData.order
              };
              if (!body.id) return;
              toast
                .promise(
                  kategoriLayananService.upsertKategoriLayanan(body),

                  {
                    loading: 'Update data ...',
                    error: <b>Maaf, terjadi kesalahan</b>,
                    success: <b>Data berhasil diubah</b>
                  }
                )
                .then(() => {
                  setToggleRefresh(!toggleRefresh);
                });
            } catch (error) {
              toast.error(error.message);
            }
          }
        },
        {
          label: 'Tidak',
          onClick: () => console.log('No')
        }
      ]
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - kategoriLayanan.length) : 0;

  const filteredData = applySortFilter(kategoriLayanan, getComparator(order, orderBy), filterName);
  console.log('data', filterName);
  const isDataNotFound = filteredData.length === 0;

  const getKategoriLayanan = async () => {
    try {
      const result = await kategoriLayananService.getKategoriLayanan();
      setKategoriLayanan(result?.data?.meta?.categories);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getKategoriLayanan();
  }, [toggleRefresh, user]);

  const getStatusColor = (status) => {
    if (status.toLowerCase() === 'inactive') return 'warning';
    if (status.toLowerCase() === 'active') return 'success';

    return 'secondary';
  };

  return (
    <Page title="Setting | Peladen Pemda DIY">
      {isEligible('page_setting') ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Setting
            </Typography>
          </Stack>

          <Stack direction="column" spacing={2} py={2}>
            <Typography variant="body2">
              Halaman ini digunakan untuk melakukan manajemen kategori layanan.
            </Typography>
          </Stack>

          <Card>
            <SettingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <SettingListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={kategoriLayanan.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => {
                        const { id, name, summary, status, order } = row;

                        return (
                          <TableRow hover key={id} tabIndex={-1}>
                            <TableCell align="left" />
                            <TableCell align="left">{id}</TableCell>
                            <TableCell align="left">{name}</TableCell>
                            <TableCell align="left">{summary}</TableCell>
                            <TableCell align="left">
                              <Label variant="ghost" color={getStatusColor(status)}>
                                {sentenceCase(status || 'undefined')}
                              </Label>
                            </TableCell>
                            <TableCell align="right">
                              <SettingMoreMenu
                                onUpdate={updateData}
                                rowData={{ id, order, status }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {isDataNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={kategoriLayanan.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      ) : (
        <AccessRequired />
      )}
    </Page>
  );
}
